export var ELEMENT_TYPE = /* @__PURE__ */ ((ELEMENT_TYPE2) => {
  ELEMENT_TYPE2["TEXT"] = "text";
  ELEMENT_TYPE2["IMAGE"] = "image";
  ELEMENT_TYPE2["LOGO"] = "logo";
  ELEMENT_TYPE2["QUIZ"] = "quiz";
  ELEMENT_TYPE2["EMAIL_FIELD"] = "email_field";
  ELEMENT_TYPE2["PHONE_FIELD"] = "phone_field";
  ELEMENT_TYPE2["BUTTON"] = "button";
  ELEMENT_TYPE2["TERMS"] = "terms";
  ELEMENT_TYPE2["SPINNER"] = "spinner";
  return ELEMENT_TYPE2;
})(ELEMENT_TYPE || {});
export var TEMPLATE_CANVAS_TYPE = /* @__PURE__ */ ((TEMPLATE_CANVAS_TYPE2) => {
  TEMPLATE_CANVAS_TYPE2["SINGLE_IMAGE"] = "single_image";
  TEMPLATE_CANVAS_TYPE2["MULTI_IMAGE"] = "multi_image";
  return TEMPLATE_CANVAS_TYPE2;
})(TEMPLATE_CANVAS_TYPE || {});
